import React from 'react';

import { Divider } from 'antd';

import DownloadFolderBasicSetting from './DownloadFolderBasicSetting';
import DownloadFolderItemsSetting from './DownloadFolderItemsSetting';

const DownloadFolderSettings = (props) => {
  const { visible } = props;

  return (
    <div
      className='download-folder__download-settings'
      style={{ display: visible ? 'block' : 'none' }}
    >
      <DownloadFolderBasicSetting />

      <Divider style={{ margin: '8px auto', minWidth: '60%', width: '60%' }} />

      <DownloadFolderItemsSetting />
    </div>
  );
};

export default DownloadFolderSettings;
